<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Redigera försening
      </v-card-title>

      <v-card-text class="mt-2">
        <v-row>
          <v-col>
            <v-text-field
              label="Tågnummer"
              outlined
              type="number"
              v-model.number="model.train_number"
              :rules="[required]"
            />
          </v-col>
          <DelayTypeField />
        </v-row>

        <DelayLocationFields />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="updatePending">
          Redigera försening
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import DelayTypeField from './DelayForm/DelayTypeField'
import DelayLocationFields from './DelayForm/DelayLocationFields'

export default {
  name: 'DelayEditModal',

  components: {
    DelayTypeField,
    DelayLocationFields
  },

  props: {
    item: Object
  },

  data: () => ({
    required,
    valid: true,
    updatePending: false
  }),

  created() {
    const updateModel = Object.keys(this.model).reduce((acc, key) => {
      if (['location_time'].includes(key)) {
        acc[key] = new Date(this.item[key])
      } else if (key === 'uuid') {
        acc[key] = this.model[key]
      } else {
        acc[key] = this.item[key]
      }
      return acc
    }, {})

    this.$store.set('delay/model', {
      ...updateModel
    })
  },

  computed: {
    model: sync('delay/model')
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.updatePending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: ReplaceDelayInput!) {
            replaceDelay(payload: $payload) {
              delay_uuid
            }
          }
        `,
        variables: {
          payload: {
            delete_uuid: this.item.uuid,
            payload: this.model
          }
        }
      })

      this.updatePending = false
      this.$store.set(`delay/data@${this.item.uuid}.deleted`, true)
      this.$store.set(`delay/data@${this.model.uuid}`, this.model)
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('delay/resetModel')
      this.$emit('close')
    }
  }
}
</script>
